import { A11y, Autoplay, Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import type { Swiper as SwiperProps } from 'swiper/types';

import { CarouselNavigation } from '@components/CarouselNavigation';
import { SanityImage } from '@components/SanityImage';

import { useSwiperMotionPreference } from '@hooks/useSwiperMotionPreference';
import { CmsImage } from '@interfaces/media';

import styles from './RecipeCarousel.module.css';

interface RecipeCarouselProps {
	featuredRecipes: CmsImage[];
	style?: React.CSSProperties;
	showNavigation?: boolean;
	paginationClickable?: boolean;
	onSlideChange?: (slide: SwiperProps) => void;
}

export const RecipeCarousel: React.VFC<RecipeCarouselProps> = ({
	featuredRecipes,
	style,
	showNavigation = true,
	paginationClickable = false,
	onSlideChange,
}) => {
	const { swiperMotionConfig, onSwiper } = useSwiperMotionPreference();

	return (
		<Swiper
			autoplay={{
				delay: 8000,
				disableOnInteraction: false,
				waitForTransition: false,
			}}
			className={styles.carousel}
			grabCursor
			loop
			modules={[Pagination, A11y, Autoplay, Navigation]}
			onSlideChange={onSlideChange}
			onSwiper={onSwiper}
			pagination={{ clickable: paginationClickable }}
			slidesPerView={1}
			speed={swiperMotionConfig.speed}
			style={style}
		>
			{showNavigation ? <CarouselNavigation /> : null}

			{featuredRecipes.map((image) => (
				<SwiperSlide key={image.alt}>
					<SanityImage className={styles.image} image={image} />
				</SwiperSlide>
			))}
		</Swiper>
	);
};
